// extracted by mini-css-extract-plugin
export var cardIcon = "_am-4";
export var checkboxCard = "_am-0";
export var checkboxCardSelected = "_am-1";
export var disabled = "_am-2";
export var outerBorder = "_am-3";
export var spacerMedium = "_am-7";
export var spacerSmall = "_am-6";
export var spacerXsmall = "_am-5";